//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import activeList from './active-list';

export default {
    name: 'my-active',
    components: {
        activeList,
        BottomNav,
    },
    data() {
        return {
            memberInfo: {}
        }
    },
    methods: {
        getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.memberInfo = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.memberInfo.id);
            }).finally(() => {
                this.$toast.clear();
            });
        },

        handleClick() {
            this.$router.push({name: 'user'})
        }
    },
    created() {
        this.getMyMember()
    }
};
